import { render, staticRenderFns } from "./LastNews.vue?vue&type=template&id=3aecebf6&scoped=true&"
import script from "./LastNews.vue?vue&type=script&lang=js&"
export * from "./LastNews.vue?vue&type=script&lang=js&"
import style0 from "./LastNews.vue?vue&type=style&index=0&id=3aecebf6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aecebf6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
